var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgParametrization = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83D\uDD39 Icon Color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1.-Structured-Index---07",
    transform: "translate(-302.000000, -213.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01",
    transform: "translate(299.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-view_list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5 L3,19 L20,19 L20,5 L3,5 Z M7,7 L7,9 L5,9 L5,7 L7,7 Z M5,13 L5,11 L7,11 L7,13 L5,13 Z M5,15 L7,15 L7,17 L5,17 L5,15 Z M18,17 L9,17 L9,15 L18,15 L18,17 Z M18,13 L9,13 L9,11 L18,11 L18,13 Z M18,9 L9,9 L9,7 L18,7 L18,9 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgParametrization, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/parametrization.a37bc0fb.svg";
export { ForwardRef as ReactComponent };